import { defineStore } from "pinia";
import { ref } from "vue";
import { AddFamilyMemberRequest, FamilyMember } from "@/types/familyTypes";
import {
  fetchDeleteFamilyMember,
  fetchFamilyMembers,
  fetchStoreFamilyMember,
  fetchUpdateFamilyMember,
} from "@/api/family";

export const useFamilyStore = defineStore("familyStore", () => {
  const familyMembers = ref<FamilyMember[]>([]);
  const isLoaded = ref(false);

  async function loadIfNeeded() {
    try {
      familyMembers.value = await fetchFamilyMembers();
    } finally {
      isLoaded.value = true;
    }
  }

  async function addFamilyMember(request: AddFamilyMemberRequest) {
    familyMembers.value.push(await fetchStoreFamilyMember(request));
  }

  async function updateFamilyMember(
    request: AddFamilyMemberRequest,
    familyMember: FamilyMember
  ) {
    const updatedFamilyMember = await fetchUpdateFamilyMember(
      request,
      familyMember.id
    );
    const updatedIndex = familyMembers.value.findIndex(
      (member) => member.id === updatedFamilyMember.id
    );
    if (updatedIndex >= 0) {
      familyMembers.value[updatedIndex] = updatedFamilyMember;
    }
  }

  async function deleteFamilyMember(familyMember: FamilyMember) {
    const res = await fetchDeleteFamilyMember(familyMember.id);
    if (res.status === 200) {
      familyMembers.value = familyMembers.value.filter(
        (item) => item.id !== familyMember.id
      );
    }
  }

  return {
    familyMembers,
    addFamilyMember,
    loadIfNeeded,
    deleteFamilyMember,
    updateFamilyMember,
  };
});
